import { render, staticRenderFns } from "./SkeletonWidget.vue?vue&type=template&id=37ea5a92&scoped=true"
import script from "./SkeletonWidget.vue?vue&type=script&lang=js"
export * from "./SkeletonWidget.vue?vue&type=script&lang=js"
import style0 from "./SkeletonWidget.vue?vue&type=style&index=0&id=37ea5a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea5a92",
  null
  
)

export default component.exports